import {
  IonBackButton,
  IonButtons,
  IonHeader,
  IonMenuButton,
  IonTitle,
  IonToolbar
} from "@ionic/react";

import { ReactComponent as MenuIcon } from "../assets/graphics/menu.svg";

const Header: React.FC<{
  title: string;
  back?: boolean;
  backHref?: string;
  classes?: string;
  // backAction?: () => void;
}> = ({ title, back, backHref, classes }) => {
  return (
    <IonHeader className={classes}>
      <IonToolbar>
        {back && (
          <IonButtons slot="start">
            <IonBackButton defaultHref={backHref} className="text-white" />
          </IonButtons>
        )}
        <IonTitle className="capitalize font-base">{title}</IonTitle>
        <IonButtons slot="end">
          <IonMenuButton>
            <MenuIcon />
          </IonMenuButton>
        </IonButtons>
      </IonToolbar>
    </IonHeader>
  );
};

export default Header;
